export interface IDonorConnectCenterStats {
    id: number,
    centerAlias: string,
    centerName: string,
    isMicrositeParticipant: boolean,
    isAcceptingReferrals: boolean,
    isKidneyForLifeParticipant: boolean,
    isDcnParticipant: boolean,
    isInDonorShield: boolean
}